
import React, { useEffect, useState } from "react"
import { md, pki } from "node-forge"
import classNames from "classnames"

const CreateCsr = ({privateKey, csrfToken}) => {
  const [publicKey, setPublicKey] = useState(null)
  const [csr, setCsr] = useState(null)
  const [csrPem, setCsrPem] = useState(null)
  const [downloadUrl, setDownloadUrl] = useState(null)

  const [commonName, setCommonName] = useState("")
  const [countryName, setCountryName] = useState("")
  const [stateProvince, setStateProvince] = useState("")

  const [localityName, setLocalityName] = useState("")
  const [organizationName, setOrganizationName] = useState("")
  const [organizationUnit, setOrganizationUnit] = useState("")

  const reset = () => {
    setCsr(null)
    setDownloadUrl(null)
    setCsrPem(null)
  }

  useEffect(() => {
    if (!privateKey) {
      return
    }
    const publicKey = pki.rsa.setPublicKey(privateKey.n, privateKey.e);
    setPublicKey(publicKey)
	reset()
  }, [privateKey])

  const handleSubmit = (e) => {
    e.preventDefault()

    var csr = pki.createCertificationRequest();
    csr.publicKey = publicKey;
    const subject = []

    // Common name
    if (commonName)
      subject.push({name: 'commonName', value: commonName})

    // Country name
    if (countryName)
      subject.push({name: 'countryName', value: countryName})

    // State or province
    if (stateProvince)
      subject.push({shortName: 'ST', value: stateProvince})

    // Locality name
    if (localityName)
      subject.push({name: 'localityName', value: localityName})

    // Organization name
    if (organizationName)
      subject.push({name: 'organizationName', value: organizationName})

    // Organization unit
    if (organizationUnit)
      subject.push({shortName: 'OU', value: organizationUnit})

    csr.setSubject(subject)
    csr.sign(privateKey)
    setCsr(csr)
    
    const pem = pki.certificationRequestToPem(csr)
    setCsrPem(pem)
    const blob = new Blob([pem], {type: 'application/x-pem-file'})
    const url = URL.createObjectURL(blob)
    setDownloadUrl(url)
  }

  if (!privateKey) {
    return <p>No key available</p>
  }

  return (<>
    <form onSubmit={(e) => handleSubmit(e)}>
      <div className="form-group">
        <label htmlFor="common-name">Common name</label>
        <input className="form-control" id="common-name" type="text"
               value={commonName} required
               onChange={e => setCommonName(e.target.value) || reset()} />
      </div>

      <div className="form-group">
        <label htmlFor="country-name">Country name <small className="text-muted">(optional)</small></label>
        <input className="form-control" id="country-name" type="text"
               value={countryName}
               placeholder="e.g. DE, US, FR"
               onChange={e => setCountryName(e.target.value) || reset()} />
      </div>

      <div className="form-group">
        <label htmlFor="state-province">State province <small className="text-muted">(optional)</small></label>
        <input className="form-control" id="state-province" type="text"
               value={stateProvince}
               onChange={e => setStateProvince(e.target.value) || reset()} />
      </div>

      <div className="form-group">
        <label htmlFor="locality-name">Locality name <small className="text-muted">(optional)</small></label>
        <input className="form-control" id="locality-name" type="text"
               value={localityName}
               onChange={e => setLocalityName(e.target.value) || reset()} />
      </div>

      <div className="form-group">
        <label htmlFor="organization-name">Organization name <small className="text-muted">(optional)</small></label>
        <input className="form-control" id="organization-name" type="text"
               value={organizationName}
               onChange={e => setOrganizationName(e.target.value) || reset()} />
      </div>

      <div className="form-group">
        <label htmlFor="organization-unit">Organizational unit <small className="text-muted">(optional)</small></label>
        <input className="form-control" id="organization-unit" type="text"
               value={organizationUnit}
               onChange={e => setOrganizationUnit(e.target.value) || reset()} />
      </div>
      <div>
        <button disabled={!commonName}
                className={classNames("btn", "m-1",
                                      {"btn-primary": !downloadUrl},
                                      {"btn-outline-primary": downloadUrl})}
                type="submit"> 
          Create CSR
        </button>
      </div>
    </form>
    { downloadUrl && <>
      <hr />
      <form action="" method="post">
        <input type="hidden" name="csr_pem" value={csrPem} />
        <input type="hidden" name="csrfmiddlewaretoken" value={csrfToken} />
        <button className="btn btn-primary m-1" type="submit">
          Submit CSR
        </button>
        <a className="btn btn-outline-secondary m-1" download="csr.pem" href={downloadUrl}>
          Download CSR
        </a>
      </form>
    </>}
  </>)
}

export default CreateCsr
